<template>
  <page-wrapper v-bind="pageWrapper">
    <div class="row requested-package-detail-page">
      <div class="col-4 package">
        <h2 class="title">Package</h2>
        <div class="package-detail" v-if="pack">
          <div class="row mb-2">
            <div class="col-sm-12 col-lg-4">
              <img class="img-fluid d-block mb-2" :src="pack.coverUrl" />
            </div>
            <div class="col-sm-12 col-lg-8">
              <p>ชื่อ</p>
              <div class="mb-2">{{ pack.name }}</div>
              <p>ราคา</p>
              <div class="mb-2">{{ pack.price }}</div>
              <p>รอบบิล</p>
              <div class="mb-2">{{ pack.billingCycle }}</div>
            </div>
          </div>
          <p>บริการ</p>
          <service-list-item
            class="service"
            v-for="service in pack.services"
            v-bind="service"
            :key="service.id"
          ></service-list-item>
        </div>
      </div>
      <div class="col-8 request-list">
        <h2 class="title">Requested ({{ totalRequested }})</h2>
        <p class="total-count" v-if="list.length">{{ totalCount }} โครงการ</p>
        <div class="requested" v-for="requested in requestedList" :key="requested.key">
          <div class="number">
            <h4 class="title">{{ requested.numberOfRequested }}</h4>
            <p class="subtitle">คำร้อง</p>
          </div>
          <div class="project">{{ requested.project }}</div>
          <div class="actions">
            <sc-button
              variant="primary"
              size="sm"
              @click="handleClickDoneButton(requested.deleteParams)"
            >จัดการแล้ว</sc-button>
            <sc-button variant="secondary" size="sm" :route="requested.route">เพิ่ม Package</sc-button>
          </div>
        </div>
        <div class="wrapper small text-right mt-4" v-if="list.length">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :size="10"
            :current-page="queryParams.page"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
        <p class="text-center" v-if="!list.length">ไม่มีข้อมูล</p>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { Input as ElInput, Pagination as ElPagination } from "element-ui";

import { baanRueJaiClient } from "@/dependencies";
import { toCamelCaseObject } from "@/lib/util";
import PageWrapper from "@/lib/components/PageWrapper";
import ProjectSelect from "@/lib/components/ProjectSelect";
import ScButton from "@/lib/components/ScButton";
import ServiceListItem from "../../services/components/ServiceListItem";
import {
  formatCurrencyAndTwoDecimalsString
} from "@/lib/formatter";

export default {
  components: { ElInput, ElPagination, PageWrapper, ProjectSelect, ScButton, ServiceListItem },
  data() {
    const selectedPackage = null;
    const list = [];
    const total = 0;
    const totalRequested = 0;

    return {
      selectedPackage,
      list,
      total,
      totalRequested
    };
  },
  computed: {
    pageWrapper() {
      return {
        title: "Requested Package Detail",
        hasPad: true
      };
    },
    totalCount() {
      const limit = 10;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.list.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.queryParams.page;
      const end = (isLastPage ? total : currentPage * limit).toLocaleString();
      const start = ((isLastPage ? limit * currentPage - limit : end - limit) + 1).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
    requestedList() {
      return this.list.map((item, index) => {
        const key = index;
        const project = `${item.projectCode} ${item.projectName}`;
        const numberOfRequested = item.requestCount;
        const projectId = item.projectId;
        const deleteParams = { projectId, packageId: this.packageId };
        const route = { name: "PackageCreatePage", query: { id: this.packageId, projectId } };

        return { key, project, numberOfRequested, route, deleteParams };
      });
    },
    pack() {
      if (!this.selectedPackage) {
        return null;
      }

      const name = this.selectedPackage.name;
      const price = `${formatCurrencyAndTwoDecimalsString(
        this.selectedPackage.price / 100
      )} บาท`;
      const billingCycle = `${this.selectedPackage.billing_cycle.toLocaleString()} เดือน`;
      const coverUrl = this.selectedPackage.image_url;
      const pack = {
        name,
        price,
        billingCycle,
        coverUrl
      };

      const services = this.selectedPackage.services.map(service => {
        const { id, name, short_description: shortDescription, description } = service;
        const provider = {
          ...service.provider,
          logoUrl: service.provider.logo_url
        };

        return {
          id,
          name,
          shortDescription,
          description,
          provider
        };
      });

      pack.services = services;

      return pack;
    },
    packageId() {
      return this.$route.params.id;
    },
    queryParams() {
      return {
        page: this.$route.query.page || 1
      };
    }
  },
  watch: {
    "$route.query": "setupData"
  },
  mounted() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    async setupData() {
      this.setupDataSelectedPackage();
      this.setupDataList();
    },
    async setupDataList() {
      const { requestPackages, count, total } = await this.fetchList();
      this.list = requestPackages;
      this.total = count;
      this.totalRequested = total;
    },
    async setupDataSelectedPackage() {
      this.selectedPackage = await this.fetchPackage();
    },
    async fetchPackage() {
      const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.get(this.packageId);

      return response.data.result;
    },
    async fetchList() {
      const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.getRequestPackageDetail(this.packageId, this.queryParams);

      return toCamelCaseObject(response.data.result);
    },
    handleCurrentChange(page) {
      this.$router.replace({ query: { ...this.$route.query, page } });
    },
    async handleClickDoneButton(params) {
      const response = await baanRueJaiClient.admin.subscriptions.recommend_packages.deleteRequestProjectPackage(params);

      alert("จัดการเรียบร้อย");

      if (this.queryParams.page > 1) {
        this.$router.replace({ query: { ...this.$route.query, page: 1 } });
        return;
      }

      this.setupDataList();
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 2rem;
}

.wrapper.small {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.requested-package-detail-page {
  .title {
    font-size: 1.25rem;
    margin-bottom: 2rem;
  }

  .total-count {
    margin-top: -1rem;
    margin-bottom: 2rem;
  }

  .service {
    padding-left: 0;
    padding-right: 0;
  }

  .package {
    border-right: 1px solid #ddd;
  }

  .requested {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 70px 1fr 200px;
    align-items: center;

    padding: 0.5rem 0;

    > .number {
      font-size: 1rem;

      > .title,
      > .subtitle {
        margin: 0;
        text-align: center;
        line-height: 1.4;
      }

      > .subtitle {
        font-size: 0.75rem;
        color: #888;
      }
    }

    > .project {
      font-size: 0.875rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/requested-packages/pages/RequestedPackageDetailPage.vue